import React from 'react'

import SolanaProvider from '@/lib/solana/provider/Solana'

import GlobalMethodProvider from './GlobalMethodProvider'
import ThemeProvider from './ThemeProvider'

const Providers: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ThemeProvider>
    <SolanaProvider>
      <GlobalMethodProvider>{children}</GlobalMethodProvider>
    </SolanaProvider>
  </ThemeProvider>
)

export default Providers
